import * as React from "react";

import {
	Create,
	SimpleForm,
	CreateProps,
	BooleanInput,
	TextInput,
	useGetIdentity,
	regex,
} from "react-admin";
import { useMediaQuery } from "@material-ui/core";
import labelsTranslation from "../translations/tranlation";
import { DoctorSaleTitle } from "../doctorSale/DoctorSaleTitle";
import { useQuery } from "@apollo/client";
import {
	gql,
	ApolloClient,
	InMemoryCache,
	createHttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { CREDENTIALS_LOCAL_STORAGE_ITEM } from "../constants";
const validatePatientCreation = (values: any) => {
	const errors: any = {};
	if (!values.firstName) {
		errors.firstName = "لطفا نام را وارد نمایید";
	}
	if (!values.mobile) {
		errors.mobile = "لطفا شماره موبایل را وارد نمایید";
	}
	if (!values.lastName) {
		errors.lastName = "لطفا نام خانوادگی را وارد نمایید";
	}
	if (!values.doctorComment) {
		errors.doctorComment = "لطفا توضیحات را وارد نمایید";
	}
	return errors;
};

const validateMobile = regex(
	/^((0)9\d{9})$/,
	"شماره موبایل را صحیح وارد نماید"
);

const authLink = setContext((_, { headers }) => {
	// get the authentication token from local storage if it exists
	const token = localStorage.getItem(CREDENTIALS_LOCAL_STORAGE_ITEM);
	// return the headers to the context so httpLink can read them
	return {
		headers: {
			...headers,
			authorization: token,
		},
	};
});

const httpLink = createHttpLink({
	uri: `${process.env.REACT_APP_SERVER_ADDRESS_3015}/graphql`,
});

const client = new ApolloClient({
	link: authLink.concat(httpLink),
	cache: new InMemoryCache(),
});

const GET_AUTH_USER = gql`
	query getAuthUser($where: AuthUserWhereUniqueInput!) {
		authUser(where: $where) {
			id
			firstName
			lastName
			roles
		}
	}
`;

export const PatientCreate = (props: CreateProps): React.ReactElement => {
	const { loaded, identity } = useGetIdentity();
	const MQBiggerMD = useMediaQuery((theme: any) => theme.breakpoints.up("md"));
	const [userInfo, setUserInfo] = React.useState<{
		firstName: string;
		lastName: string;
		role: string;
	} | null>(null);
	const setUserRole = (roles: any[]): string => {
		if (roles.length === 1) {
			if (roles.includes("doctor_sale.doctor")) {
				return "doctor_sale.doctor";
			} else if (roles.includes("sport_coach.coach")) {
				return "sport_coach.coach";
			}
		}
		return "test";
	};
	const getUserInfo = () => {
		identity &&
			client
				.query({
					query: GET_AUTH_USER,
					variables: {
						where: {
							id: identity.id,
						},
					},
				})
				.then((res) => {
					console.log({
						firstName: res.data.authUser.firstName,
						lastName: res.data.authUser.lastName,
						role: setUserRole(res.data.authUser.roles["doctor_sale"]),
					});
					setUserInfo({
						...userInfo,
						firstName: res.data.authUser.firstName,
						lastName: res.data.authUser.lastName,
						role: setUserRole(res.data.authUser.roles["doctor_sale"]),
					});
				})
				.catch((e) => {
					console.log(e);
				});
	};
	React.useEffect(() => {
		loaded && getUserInfo();
	}, [loaded]);
	return (
		<>
			{loaded && userInfo && (
				<div
					className=""
					style={{ width: MQBiggerMD ? "40%" : "100%", padding: "1rem" }}
				>
					<Create {...props} title={labelsTranslation.userCreate.title}>
						<SimpleForm validate={validatePatientCreation}>
							<BooleanInput
								label="Archived"
								source="archived"
								defaultValue={false}
								disabled
								style={{ display: "none" }}
							/>
							<TextInput
								style={{ width: "100%" }}
								label={labelsTranslation.userCreate.fName}
								source="firstName"
							/>
							<TextInput
								style={{ width: "100%" }}
								label={labelsTranslation.userCreate.lName}
								source="lastName"
							/>
							<TextInput
								style={{ width: "100%" }}
								label={labelsTranslation.userCreate.mobile}
								validate={validateMobile}
								source="mobile"
							/>
							<TextInput
								style={{ width: "100%" }}
								label={labelsTranslation.userCreate.comment}
								rows={5}
								multiline
								source="doctorComment"
							/>
							<TextInput
								style={{ display: "none" }}
								label="شناسه دکتر"
								source="doctorId"
								disabled
								defaultValue={identity?.id}
							/>
							<TextInput
								source="doctor"
								style={{ display: "none" }}
								disabled
								defaultValue={userInfo}
								// parse={(v: any) => JSON.parse(v)}
								format={(v: any) => JSON.stringify(v)}
							/>

							{/* <ReferenceInput
					source="doctorsale.id"
					reference="DoctorSale"
					label="دکتر فروش"
				>
					<TextInput source="doctorSale" disabled defaultValue={identity?.id} />
				</ReferenceInput> */}
							{/* <ReferenceInput
					source="doctorsale.id"
					reference="DoctorSale"
					label="Doctor Sale"
				>
					<SelectInput optionText={DoctorSaleTitle} />
				</ReferenceInput> */}

							{/* <TextInput
					label="Sale Representative Comment"
					multiline
					source="saleRepresentativeComment"
				/> */}
						</SimpleForm>
					</Create>
				</div>
			)}
		</>
	);
};
